import { Skeleton } from '@/shared/ui/skeleton'

/** Placeholder of the translation editor (language pills + name/description fields) while the form loads. */
export function TranslationsSkeleton() {
  return (
    <div className="space-y-4 rounded-xl border border-zinc-200 p-4">
      <div className="flex gap-2">
        <Skeleton className="h-7 w-14 rounded-full" />
        <Skeleton className="h-7 w-14 rounded-full" />
        <Skeleton className="h-7 w-14 rounded-full" />
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="space-y-1.5">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-9 w-full rounded-md" />
        </div>
        <div className="space-y-1.5">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-[124px] w-full rounded-md" />
        </div>
      </div>
    </div>
  )
}
